function Icon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.727581 14.6309C4.35133 8.73706 9.09418 8.55558 14.6816 11.2461C16.1918 12.0011 17.9124 12.8168 18.7881 13.21C19.091 13.3615 19.242 13.7539 19.0918 14.0566L17.1279 18.499C16.9775 18.8011 16.6141 18.9523 16.2822 18.8008L12.1738 16.8672C9.21424 15.4464 7.5534 15.1447 5.92192 17.834C5.71355 18.1725 5.51173 18.5156 5.31742 18.8623C5.13603 19.1638 4.74446 19.2551 4.44242 19.0742L0.303753 16.5352C0.00187755 16.3536 -0.08781 15.9602 0.092815 15.6582C0.300347 15.3133 0.512076 14.9709 0.727581 14.6309ZM14.6816 0.304641C14.863 0.00283876 15.2546 -0.0883474 15.5566 0.0927263L19.6953 2.63179C19.9969 2.8133 20.0881 3.20586 19.9072 3.50776C19.6996 3.85277 19.4871 4.19601 19.2715 4.53608C15.6478 10.4295 10.9059 10.5813 5.31742 7.92085C3.80809 7.16579 2.0867 6.34918 1.21098 5.956C0.908948 5.80538 0.756995 5.41214 0.908245 5.10933L2.87113 0.666945C3.02258 0.365089 3.38507 0.213764 3.71684 0.365187L7.82524 2.29878C10.785 3.71971 12.4454 4.02151 14.0771 1.33198C14.2857 0.99375 14.4877 0.651501 14.6816 0.304641Z"
        fill="url(#paint0_linear_8288_19)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8288_19"
          x1="1.00713"
          y1="-1.23087"
          x2="13.5062"
          y2="5.9466"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0052CC" />
          <stop offset="0.918" stopColor="#2380FB" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
